export default __webpack_public_path__ + "static/media/14.ca0ce005.jpg";